module.exports = __webpack_public_path__ + "img/pic2.4e86079a.png";